(function HotelEngineSpecialtyRates($, Adzuki)
{
	'use strict';

	const component = {
		emits : ['rate-key'],
		inject: {
			$inject_availableScopes: {
				default: () => ({})
			}
		},
		props: {
			sabreHotelId: {
				type   : String,
				default: ''
			},
			specialtyRates: {
				type    : Array,
				required: false,
				default : () => []
			}
		},
		template: `
			<div class="pad20-vert-top" v-if="rates.length > 0">
				<ul class="table table-responsive table-striped">
					<li class="table-header">
						<p>Room Code</p>
						<p>Description</p>
						<p>Rate Type</p>
						<p>Avg Per Night</p>
						<p>Deposit Required</p>
						<p>Tax</p>
						<p>Total</p>
						<p></p>
					</li>
					<li
						v-for="(specialtyRate, index) in rates"
						class="table-row"
					>
						<p>
							<a @click.prevent="specialtyRateDetails(specialtyRate.rate_key, specialtyRate.room_code)">{{ specialtyRate.room_code }}</a>
						</p>
						<p>
							{{ specialtyRate.description }}
							<br>
							<span v-if="hasScope('commissions.view') && specialtyRate.commission_info">
								<i class="fas fa-fw fa-info-circle"></i> {{ specialtyRate.commission_info }}
							</span>
						</p>
						<p>
							<he-rate-badge
								:rate-key="specialtyRate.rate_key"
								:sabre-hotel-id="sabreHotelId"
								:rate-codes="[specialtyRate.client_id]"
							></he-rate-badge>
						</p>
						<p>{{ specialtyRate.avg_nightly_rate }}</p>
						<p>{{ specialtyRate.guarantee_type === 'DEP' || specialtyRate.guarantee_type === 'dep' ? 'Yes' : 'No' }}</p>
						<p v-format-currency="specialtyRate.tax"></p>
						<p v-format-currency="specialtyRate.total"></p>
						<p>
							<adzuki-loading 
								v-if="loadingRateIndex === index"
								:loader-type="'button'"
							></adzuki-loading>
							<a 
								v-else
								@click="selectRate(index, specialtyRate.rate_select_string)" 
								class="btn btn-primary"
							>
								Select Rate
							</a>
						</p>
					</li>
				</ul>
			</div>
			<div class="row pad20-vert-top" v-else><p>There are no specialty rates for this property</p></div>
			<div :class="['specialty-rates-sidebar-right', { open: sideBarOpen, close: !sideBarOpen }]" class="row">
				<div class="specialty-rates-sidebar-right-content">
					<div v-if="sideBarLoading" class="col-sm-12 pad20 align-items-center">
						<adzuki-loading></adzuki-loading>
					</div>
					<div v-else class="col-sm-12 pad20">
						<div class="text-right" @click="sideBarOpen = false">X</div>
						<div class="sd-header">
							<h3>{{ roomCode }}</h3>
							<span>{{ rateDetails.rate_plan }}</span>
						</div>
						<div class="sd-content">
							<h2>Details</h2>
							<p>{{ rateDetails.room_description }}</p>
							<p><strong>{{ rateDetails.additional_info?.title }}</strong>
								{{ rateDetails.additional_info?.text }}</p>
							<hr>
							<div class="grid-layout">
								<div class="grid-item">Avg Per Night</div>
								<div class="grid-item" v-format-currency="rateDetails.avg_nightly_rate"></div>
								<div class="grid-item">Taxes</div>
								<div class="grid-item" v-format-currency="rateDetails.total_taxes"></div>
								<div class="grid-item">Total</div>
								<div class="grid-item" v-format-currency="rateDetails.total_amount"></div>
							</div>
							<small>** INCLUDES TAXES AND SURCHARGES</small>
						</div>
					</div>
				</div>
			</div>
		`,
		data() {
			return {
				baseUri         : Adzuki.base_uri,
				sideBarLoading  : false,
				sideBarOpen     : false,
				rateDetails     : {},
				roomCode        : null,
				loadingRateIndex: null,
			};
		},
		computed: {
			// Specialty rates arrive as an array, an object keyed by rate code, or not at all.
			rates() {
				if (Array.isArray(this.specialtyRates)) {
					return this.specialtyRates.filter(Boolean);
				}

				if (this.specialtyRates && typeof this.specialtyRates === 'object') {
					return Object.values(this.specialtyRates).filter(Boolean);
				}

				return [];
			}
		},
		methods: {
			hasScope(scope) {
				const scopes    = this.$inject_availableScopes;
				const available = scopes && typeof scopes === 'object' && 'value' in scopes
					? scopes.value
					: scopes;

				return Boolean(available?.[scope]);
			},
			selectRate(rateIndex, rateKey) {
				this.loadingRateIndex = rateIndex;
				this.$emit('rate-key', rateKey);
			},
			specialtyRateDetails(rate_key, room_code) {
				this.sideBarOpen    = true;
				this.sideBarLoading = true;
				this.roomCode       = room_code;

				const url = this.baseUri + `/HotelEngine/getSpecialtyRateDetails/`+ encodeURIComponent(rate_key);

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`Error fetching Specialty Rate Details: ${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.rateDetails = data;
						this.sideBarLoading   = false;
					})
					.catch(error => {
						console.error('Error fetching Specialty Rate Details:', error);
					});
			},
		},
		watch: {
		},
	};

	Adzuki.VueComponents.HotelEngineSpecialtyRates = component;
}(jQuery, window.Adzuki || {}));
